"use client";

import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";

/**
 * Detects Supabase invite tokens in the URL hash (implicit flow) and
 * redirects to the accept-invite page, preserving the hash so the
 * Supabase client can establish the session there.
 *
 * This is needed because Supabase's local dev instance always redirects
 * to the site root when the redirectTo URL is not in its allowed list.
 */
export function InviteRedirectHandler() {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (pathname === "/admin/accept-invite") return;

    // Implicit flow: invite tokens arrive in the URL hash
    const hash = window.location.hash;
    if (hash.includes("type=invite") && hash.includes("access_token")) {
      router.replace(`/admin/accept-invite${hash}`);
      return;
    }

    // PKCE flow: invite code arrives as ?code= on the site root
    // (happens when the redirectTo URL isn't in Supabase's allowed list)
    if (pathname === "/" ) {
      const code = new URLSearchParams(window.location.search).get("code");
      if (code) {
        router.replace(`/admin/accept-invite?code=${code}`);
      }
    }
  }, [pathname, router]);

  return null;
}
